import { render, staticRenderFns } from "./PingPongCard.vue?vue&type=template&id=5c0d377e&"
import script from "./PingPongCard.vue?vue&type=script&lang=js&"
export * from "./PingPongCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports